const Konva = require('konva');

function isElementGroupNode(n) {
  if (!n || n instanceof Konva.Transformer) return false;
  if (typeof n.hasName === 'function' && n.hasName('elementGroup')) return true;
  const raw = n.attrs?.name;
  if (typeof raw === 'string' && raw.split(/\s+/).includes('elementGroup')) return true;
  return false;
}


export function pickElementGroupUnderPointerFigma(stage, pos, selectedSet, pointInRectPad) {
  const rectOpts = { relativeTo: stage };

  const resolveFromHitShape = (node) => {
    let n = node;
    while (n && n !== stage) {
      if (n instanceof Konva.Transformer) return null;
      if (isElementGroupNode(n)) {
        if (!selectedSet.has(n)) return n;
        n = n.parent;
        continue;
      }
      n = n.parent;
    }
    return null;
  };

  const shape = stage.getIntersection(pos);
  if (shape) {
    const g = resolveFromHitShape(shape);
    if (g) return g;
    return null;
  }

  const canvasLayer = stage.findOne('#canvas');
  const groups = canvasLayer ? canvasLayer.find('.elementGroup') : stage.find('.elementGroup');
  const hit = [];
  groups.forEach((group) => {
    if (selectedSet.has(group)) return;
    const r = group.getClientRect(rectOpts);
    if (pointInRectPad(r, pos.x, pos.y)) hit.push(group);
  });
  if (!hit.length) return null;
  hit.sort((a, b) => {
    const za = typeof a.getAbsoluteZIndex === 'function' ? a.getAbsoluteZIndex() : (a.zIndex?.() ?? 0);
    const zb = typeof b.getAbsoluteZIndex === 'function' ? b.getAbsoluteZIndex() : (b.zIndex?.() ?? 0);
    return zb - za;
  });
  return hit[0];
}
